module.exports = __webpack_public_path__ + "img/menu_nautilius.293ef4f3.png";